import { Input, Form } from "@renderbus/ui";
import { ThemeType } from "project-config/client-theme/client-theme";
import styled, { createGlobalStyle } from "styled-components";

export const InputComponent = styled(Input)`
  // 去除对应的增减
  &.ant-input-affix-wrapper {
    border: none;
    background-color: #212327;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  &.ant-input-outlined.ant-input-status-error:not(
      .ant-input-disabled
    ):focus-within {
    background-color: #212327;
  }
  &.ant-input-affix-wrapper:hover,
  &.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled):focus,
  &.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled):hover {
    background-color: #212327;
  }
`;

export const RechargeForm = styled(Form)`
  margin-top: 16px;
  .info-icon {
    path {
      fill: #3c7bea;
    }
  }
  .ant-form-item {
    margin-bottom: 0;
  }
  .client-amount-input {
    width: 244px;
    height: 38px;
    margin: 8px 0 4px;
    input {
      background: ${(p) => p.theme["theme-1"]};
      color: ${(p) => p.theme["color-text-1"]};
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
  .ant-form-item {
    .icon-input-wrapper {
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid ${(p) => p.theme["color-line-1"]} !important;
      background: ${(p) => p.theme["theme-1"]};
      color: ${(p) => p.theme["color-text-1"]};
      &:hover {
        border: 1px solid #4d9efd !important;
        transition: border 0.2s ease-in-out;
      }
    }
    &.ant-form-item-has-error {
      .icon-input-wrapper {
        border: 1px solid #ff1b1b !important;
        border-radius: 4px;
        color: #ff1b1b;
      }
    }
    .ant-form-item-explain-error {
      color: #ff1b1b;
    }
  }
`;

export const CustomTooltipStyle = createGlobalStyle`
  .ant-tooltip-inner {
    background: ${(p) =>
      (p.theme as ThemeType)["color-fill-6" as any]} !important;
    color: ${(p) => (p.theme as ThemeType)["color-fill-13" as any]} !important;
  }
  .ant-tooltip-arrow {
    ::before {
      background: ${(p) =>
        (p.theme as ThemeType)["color-fill-6" as any]} !important;
    }
  }

`;

export const ChangeCouponCode = styled.div`
  width: 224px;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.theme as ThemeType)["color-line-1" as any]};
  background: ${(p) => (p.theme as ThemeType)["color-fill-2" as any]};
  color: ${(p) => (p.theme as ThemeType)["color-text-1" as any]};
  position: relative;
  overflow: hidden;
  padding-left: 17px;
  .change-btn {
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 100%;
    border-left: 1px solid
      ${(p) => (p.theme as ThemeType)["color-line-1" as any]};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`;

export const CouponCodeTipWrapper = styled.div<{
  titleColor: string;
}>`
  background: ${(p) => p.theme["color-fill-12"]};
  color: ${(p) => p.theme["color-fill-13"]};
  line-height: 30px;
  min-width: 462px;
  width: max-content;
  font-size: 12px;
  border-radius: 4px;
  margin: 12px 6px 0 0;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  svg {
    margin-right: 4px;
    path {
      fill: ${(p) => p.theme[p.titleColor]};
    }
  }
  span:last-child {
    font-weight: 400;
  }
  .pre-title {
    color: ${(p) => p.theme[p.titleColor]};
  }
  .gift-tip::after,
  .gift-tip::before {
    content: "";
    width: 1px;
    height: 12px;
    background: rgba(103, 145, 255, 0.24);
    margin: 0 6px;
    display: inline-block;
    vertical-align: middle;
  }
`;
